export const PROGRAM_CODES: Record<string, string> = {
  'beginning-sound': 'LIT-BEGISOU',
  'bins-big-small': 'SRT-BIGSMA',
  'bins-colours': 'SRT-RBY',
  'bins-food-clothes-toys': 'SRT-FCT',
  'bins-healthy': 'SRT-EDSF',
  'bins-hot-cold': 'SRT-HOTCOL',
  'bins-land-sea-sky': 'SRT-LSS',
  'bins-letters-numbers': 'SRT-LETTNUM',
  'bins-living': 'SRT-LNL-BIN',
  'brushing-teeth': 'DLY-BTS',
  'chain-bag': 'DLY-PSB',
  'chain-coat': 'DLY-PUTTCOA',
  'chain-handwashing': 'DLY-WASHHAN',
  'chain-teeth': 'DLY-BRUSTEE',
  'chain-toast': 'DLY-MAKITOA',
  'chain-toilet': 'DLY-USINTOI',
  'copy-memory': 'MAT-FROMMEM',
  'copy-three': 'MAT-33',
  'copy-two': 'MAT-22',
  'count-objects': 'MTH-COUNOBJ',
  'count-on': 'MTH-COUNT',
  'dress-basic': 'DLY-GETTDRE',
  'dress-cold': 'DLY-COLDDAY',
  'dress-rain': 'DLY-RAINDAY',
  'dress-school': 'DLY-READSCH',
  'dress-sun': 'DLY-SUNNDAY',
  'dressing-sequence': 'DLY-DRESS',
  'echoic-phrases': 'ECH-PHRAS',
  'echoic-rhymes': 'ECH-RHYME',
  'echoic-sentences': 'ECH-SENTE',
  'echoic-single-sounds': 'ECH-SINGSOU',
  'echoic-songs': 'ECH-SONGS',
  'echoic-syllables': 'ECH-SYLLA',
  'echoic-tongue-twisters': 'ECH-TONGTWI',
  'echoic-words': 'ECH-WORDS',
  'emotion-to-scenario': 'SOC-EMOTSCE',
  'ending-sound': 'LIT-ENDISOU',
  'eye-contact-timer': 'SOC-ECT',
  'find-body': 'REC-BODYPAR-TCH',
  'find-car': 'REC-PARTCAR-TCH',
  'find-dog': 'REC-PARTDOG-TCH',
  'find-face': 'REC-PARTFAC-TCH',
  'find-house': 'REC-PARTHOU-TCH',
  'find-plane': 'REC-PARTAER-TCH',
  'findall-categories': 'REC-CATEG-ALL',
  'findall-colours': 'REC-COLOU-ALL',
  'findall-features': 'REC-FEATU-ALL',
  'greeting-choice': 'SOC-GREECHO',
  'handwashing': 'DLY-HANDSTE',
  'identify-emotion': 'SOC-IDENEMO',
  'imitate-fine-motor': 'MOT-FINE',
  'imitate-gross-motor': 'MOT-GROSS',
  'imitate-multi-step': 'MOT-MULTSTE',
  'imitate-oral-motor': 'MOT-ORAL',
  'imitate-with-objects': 'MOT-OBJEC',
  'intraverbal-feature': 'INT-FEATU',
  'intraverbal-fill-in': 'INT-FILL',
  'intraverbal-function': 'INT-FUNCT',
  'intraverbal-letter-sounds': 'INT-LETTSOU',
  'intraverbal-name-category': 'INT-NAMECAT',
  'intraverbal-number-facts': 'INT-NUMBFAC',
  'intraverbal-opposites': 'INT-OPPOS',
  'intraverbal-story-recall': 'INT-STORREC',
  'intraverbal-synonyms': 'INT-SAMEMEA',
  'intraverbal-wh': 'INT-WHQUE',
  'label-bicycle': 'REC-PARTBIC',
  'label-bird': 'REC-PARTBIR',
  'label-body': 'REC-BODYPAR-LBL',
  'label-car': 'REC-PARTCAR-LBL',
  'label-dog': 'REC-PARTDOG-LBL',
  'label-face': 'REC-PARTFAC-LBL',
  'label-fish': 'REC-PARTFIS',
  'label-flower': 'REC-PARTFLO',
  'label-house': 'REC-PARTHOU-LBL',
  'label-plane': 'REC-PARTAER-LBL',
  'letter-id': 'LIT-LETTID',
  'letter-sound-id': 'LIT-LSI',
  'mand-attention': 'MND-ATTEN',
  'mand-break': 'MND-BREAK',
  'mand-choice': 'MND-CHOIC',
  'mand-help': 'MND-HELP',
  'mand-information': 'MND-INFOR',
  'mand-pictures': 'MND-PICTU',
  'match-case': 'MAT-ULC',
  'match-colors': 'MAT-COLOR',
  'match-identical-pictures': 'MAT-IDENPIC',
  'match-letters': 'MAT-LETTE',
  'match-non-identical': 'MAT-NONIDE',
  'match-numbers': 'MAT-NUMBE',
  'match-picture-to-word': 'MAT-PICTWOR',
  'match-quantity-to-numeral': 'MAT-QUANNUM',
  'match-shapes': 'MAT-SHAPE',
  'match-word-to-picture': 'MAT-WORDPIC',
  'mealtime-steps': 'DLY-MEALSTE',
  'memory-animals': 'MAT-ANIMA',
  'memory-case': 'MAT-BSL',
  'memory-feelings': 'MAT-FEELI',
  'memory-numbers': 'MAT-NUMBAMO',
  'memory-together': 'MAT-GOTOG',
  'money-recognition': 'MTH-MONEREC',
  'more-vs-less': 'MTH-MORELES',
  'number-line-jump': 'MTH-NLJ',
  'order-numbers': 'MTH-NUMBORD',
  'order-sentences': 'LIT-SENTE',
  'order-spell-colours': 'LIT-SPELCOL',
  'order-spell-cvc': 'LIT-SSW',
  'order-stories': 'SEQ-STORORD',
  'pattern-completion': 'SEQ-PATTCOM',
  'trace-capitals': 'LIT-TRACAP',
  'trace-small-letters': 'LIT-TRASMA',
  'trace-numbers': 'MTH-TRANUM',
  'picture-sentence-beach': 'LIT-PICSENT',
  'place-all': 'REC-ALLPLA',
  'place-in-on-under': 'REC-UNDER',
  'place-next-behind': 'REC-NEXTBEH',
  'receptive-actions': 'REC-ACTIO',
  'receptive-body-parts': 'REC-BODYPAR-TAP',
  'receptive-categories': 'REC-CATEG-TAP',
  'receptive-colors': 'REC-COLOR',
  'receptive-features': 'REC-FEATU-TAP',
  'receptive-function': 'REC-FUNCT',
  'receptive-letters': 'REC-LETTE',
  'receptive-numbers': 'REC-NUMBE',
  'receptive-pictures': 'REC-PICTU',
  'receptive-shapes': 'REC-SHAPE',
  'rhyming-pairs': 'LIT-RHYMPAI',
  'sentence-to-picture': 'LIT-SENTPIC',
  'sequence-alphabet': 'SEQ-ALPHA',
  'sequence-daily-routine': 'SEQ-DAILROU',
  'sequence-days': 'SEQ-DAYSWEE',
  'sequence-months': 'SEQ-MONTYEA',
  'sequence-numbers': 'SEQ-NUMBE',
  'sequence-size-order': 'SEQ-SIZEORD',
  'sequence-story-cards': 'SEQ-STORCAR',
  'sight-word-tap': 'LIT-SWT',
  'simple-addition': 'MTH-SIMPADD',
  'simple-subtraction': 'MTH-SIMPSUB',
  'sort-by-category': 'SRT-CATEG',
  'sort-by-color': 'SRT-COLOR',
  'sort-by-feature': 'SRT-FEATU',
  'sort-by-function': 'SRT-FUNCT',
  'sort-by-shape': 'SRT-SHAPE',
  'sort-by-size': 'SRT-SIZE',
  'sort-living-non-living': 'SRT-LNL-TAP',
  'sort-odd-one-out': 'SRT-OOO',
  'tact-actions': 'EXP-ACTIO',
  'tact-animals': 'EXP-ANIMA',
  'tact-buildings': 'EXP-BUILD',
  'tact-colors': 'EXP-COLOR',
  'tact-community-helpers': 'EXP-COMMHEL',
  'tact-emotions': 'EXP-EMOTI',
  'tact-foods': 'EXP-FOODS',
  'tact-letters': 'EXP-LETTE',
  'tact-locations': 'EXP-LOCAT',
  'tact-numbers': 'EXP-NUMBE',
  'tact-pictures': 'EXP-PICTU',
  'tact-shapes': 'EXP-SHAPE',
  'tact-shops': 'EXP-SHOPS',
  'tact-things-in-the-house': 'EXP-THINHOU',
  'tact-vehicles': 'EXP-VEHIC',
  'tally-marks': 'MTH-TALLMAR',
  'turn-car': 'REC-CAR',
  'turn-house': 'REC-HOUSE',
  'turn-plane': 'REC-AEROP',
  'turn-taking': 'SOC-TURNTAK',
  'wait-long': 'SOC-LONGWAI',
  'wait-short': 'SOC-SHORWAI',
  'wait-turn': 'SOC-MYTUR',
  'word-build': 'LIT-WORDBUI',
  'yesno-colours': 'REC-COLOU-YN',
  'yesno-is-it': 'REC-YN',
  'yesno-true': 'INT-THATRIG',
};
